/**
 * Belső Nyugalom — kereskedelmi beállítások.
 * Ide kerül majd a valódi checkout link és a visszaszámláló vége.
 */

/** Checkout link — minden „Kérem az azonnali hozzáférést →” gomb ide visz. */
export const checkoutUrl = 'https://belso-nyugalom.impultienda.ar/checkout'

/**
 * A visszaszámláló pontos vége (ISO dátum, időzónával).
 * A számláló ehhez az időponthoz számol, újratöltéskor nem indul újra.
 */
export const countdownEnd = '2026-10-31T23:59:00+01:00'

export const brand = 'Belső Nyugalom'
export const salePrice = '5 970 Ft'
export const listPrice = '16 970 Ft'
export const guaranteeDays = 30
